/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import ContractApi from '@/api/contract';
import { LoanEvidence } from '@/api/contract/types';
import { session } from '@/shared/utils/storage';
import { Component, Vue } from 'vue-property-decorator';

const style = require('./index.module.scss');

@Component({ name: 'YhApplyBorrowContract' })
export default class YhApplyBorrowContract extends Vue {
  private applyContractForm: LoanEvidence | null = null;

  private async created() {
    const applyContractForm: Dictionary<string> | null = session.get('applyProductForm') || null;

    if (applyContractForm) {
      this.applyContractForm = await ContractApi.contractInfo(
        applyContractForm.productId,
        '',
        applyContractForm.bankCardId,
      );
    }
  }

  private getProps(propName: string): string | number {
    if (this.applyContractForm) {
      const applyContractForm = Object.create(
        this.applyContractForm,
      ) as Dictionary<string | number>;

      if (applyContractForm[propName]) {
        return applyContractForm[propName];
      }
    }

    return '';
  }

  private render() {
    return (
      <div class={style.YhApplyBorrowContract}>
        <div class={style.content}>
          <p class={style.contentTitle}>
            <strong>个人贷款借款合同</strong>
          </p>
          <p>借款人： {this.getProps('userName')}</p>
          <p>身份证号码：{this.getProps('idCard')}</p>
          <p>家庭住址：{this.getProps('adress')}</p>
          <p>电话：{this.getProps('phone')}</p>
          <br />
          <p>贷款人：湖南三湘银行股份有限公司</p>
          <p>法定代表人：夏博辉</p>
          <p>住所地：湖南省长沙市岳麓区滨江景观大道楷林国际D座 邮编：410023</p>
          <p>联系电话：400-088-0966</p>
          <br />
          <p>
            本合同当事人为明确各自的权利、义务，遵照有关法律、法规、监管规定，经平等、自愿、协商一致，特订立本合同，承诺信守。
          </p>
          <p class={style.text}>
            <strong>
              特别提示：本合同系当事人双方在平等、自愿的基础上依法协商订立，所有合同条款均是双方真实意思表示。为维护借款人的合法权益，贷款人特提请借款人对有关双方权利义务的全部条款予以充分注意。
            </strong>
          </p>

          <p class={style.contentTitle}>
            <strong>第一章 特别签订条款</strong>
          </p>
          <p>
            <strong>第一条 贷款种类与用途</strong>
          </p>
          <p>
            此项贷款为：个人消费性贷款，贷款用途为日常消费。未经贷款人书面同意，借款人不得将贷款挪作他用。借款人不得将贷款用于无指定用途的个人支出，不得用于任何法律法规、监管规定、国家政策禁止银行贷款投入的项目、用途，包括但不限于股票、证券投资、房地产开发投资等。
          </p>
          <p>
            <strong>第二条 贷款币种与金额</strong>
          </p>
          <p>贷款金额为人民币(大写)。具体贷款金额以贷款人系统记载为准。</p>
          <p>
            <strong>第三条 贷款期限</strong>
          </p>
          <p>3.1提款期为本合同生效之日起至授信到期日。</p>
          <p>
            3.2贷款期限为 _（年/月/日），即从 _ 年 _ 月 _ 日起到 _ 年 ____ 月 _
            日止。
            本合同项下的借款期限起始日与实际放款日期不一致时，以实际放款时的贷款人系统保存的数据电文（包括但不限于借款凭证、电子回单等）所记载的放款日期为准，本条约定的借款到期日作相应调整。
          </p>
          <p>
            <strong>第四条 贷款利率与利息</strong>
          </p>
          <p>
            <p> 4.1 本合同项下贷款利率执行以下第4.1.1种利率：</p>
            <p>4.1.1固定利率：</p>
            <p>
              按贷款发放日
              _（合同签订日/贷款发放日）_（选择填写：一年期/五年期以上）_
              贷款市场报价利率（LPR）_（选择填写：加/减）_
              个基点（一个基点为0.01%），年利率为 _
              %，在贷款期间内，贷款利率不变。
            </p>
            <p>4.1.2浮动利率：</p>
            <p>
              按____ / __合同签订日/贷款发放日）__ /
              __选择填写：一年期/五年期以上）贷款市场报价利率（LPR）_ /
              _（选择填写：加/减）_ / _ 个基点（一个基点为0.01%）。
            </p>
            <p>
              本合同有效期内实行浮动利率的，如遇贷款市场报价利率（LPR）调整，贷款人根据贷款市场报价利率（LPR）的变化按本合同约定的浮动幅度__
              /__
              （选择填写：按年/按半年/按季/按月）调整贷款利率，该调整不视为对本合同的变更，不再另行通知借款人。
            </p>
            <p>
              4.2根据上条选择的合同签订日或者贷款发放日的当天如果正好是当月贷款市场报价利率（LPR）公布日的，则以前一个工作日的贷款市场报价利率（LPR）为准。
            </p>
            <p>4.3 年利率与月利率、日利率的换算方式见10.1条规定。</p>
            <p>
              4.4罚息利率：借款人未按本合同的约定按时足额偿还贷款的，贷款人有权对其加收逾期罚息，逾期罚息利率为本合同约定贷款利率的150%，罚息收取直至贷款本息清偿完毕为止。
              借款人未按合同约定用途使用贷款的，贷款人有权对其违约使用部分收取挤占挪用罚息，挤占罚息利率为本合同约定贷款利率的200%，直至贷款本息清偿完毕为止。
            </p>
            <p>
              <strong>第五条贷款发放及贷款资金支付</strong>
            </p>
            <p>
              5.1贷款发放：借款人按照贷款人的有关规定办妥贷款手续后，贷款人将贷款划入借款人以下扣款账户内。
            </p>
            <p>户名：___，账号：___。</p>
            <p>5.2贷款资金支付方式：</p>
            <p>
              全部贷款资金均由贷款人采取受托支付的方式支付至借款人交易对手账户。具体账户信息如下：
            </p>
            <p>户名：_____/_______，账号：_____/_。</p>
            <p>
              5.2.2
              全部贷款资金均由借款人自主支付，借款人须定期向贷款人汇总报告贷款资金支付和使用情况。
            </p>
            <p>
              <strong>第六条 贷款归还</strong>
            </p>
            <p>6.1.1 借款人采用等额本息方式归还贷款本息。</p>
            <p>
              6.1.2扣款日
              本合同项下贷款的首次扣款日为：放款日的次月对日，之后每期扣款日为下月的对日（每月29日前放款数据，扣款日为对应的放款日，若本月没有对应的日期，扣款日则为月末最后一天）；具体日期以贷款人出具的还款计划表为准。
            </p>
            <p>
              6.2借款人同意贷款人或贷款人委托的第三方按照本合同约定的方式从借款人提供的本人借记卡或借款人其他同名账户中扣划贷款本金和利息。
            </p>
            <p>
              如贷款人无法从上述扣款账户中直接扣划贷款本金和利息或扣划贷款本金和利息不成功的，
              借款人仍应当按本合同约定履行还款义务；如合同履行期间，借款人将绑定的银行卡账户解绑导致贷款人无法及时扣款造成贷款逾期的，由借款人承担全部违约责任和赔偿贷款人由此造成的全部损失。
            </p>
            <p>
              6.3
              借款人申请提前还款的，不收取提前还款补偿金，但借款日当天不能进行提前部分/全额还款。
            </p>
            <p>
              6.4借款人申请提前还款的，依据本合同第四条约定按日计收利息。并将全部贷款本金、利息、罚息、复利等金额一次性还清。
            </p>
            <p>
              6.5对借款人提前还款的，贷款人对借款人提前还款前已计收的贷款利息不再调整，对提前归还的贷款本金，
              从前一还款日至提前还款日按日计收利息。借款人提前归还部分贷款的，提前还款后的每月还款金额根据剩余贷款本金和剩余贷款期限重新确定，但贷款利率和还款方式不因提前还款而发生变化。
            </p>
            <p>
              6.6借款人未能在单笔借款到期日足额偿付贷款本息的，贷款人有权停止剩余授信额度的使用，并向借款人收取逾期贷款利息、罚息、复利、违约金等。
            </p>
            <p>
              <strong>第七条 纠纷的解决</strong>
            </p>
            <p>
              本合同履行过程中如发生纠纷，各方首先应友好协商解决，协商不成的，双方均可向贷款人住所地人民法院提起诉讼。
            </p>
            <p>第八条 特别约定 </p>
            <p class={style.contentTitle}>
              <strong>第二章 借贷条款</strong>
            </p>
            <p>
              <strong>第九条 贷款发放</strong>
            </p>
            <p>9.1本合同项下贷款一次性提取。</p>
            <p>
              9.2借款人要求提款时，除非下列条件已被全部满足(但贷款人届时决定放弃的条件除外)，否则贷款人无义务(但仍有权)发放贷款：
            </p>
            <p>
              9.2.1本合同及担保合同已订立并生效，且已按照贷款人的要求办妥交付、登记、备案和公证等手续。采用信用方式的，借款人符合贷款人的相关准入条件；
            </p>
            <p>
              9.2.2借款人已办妥贷款人要求的相关手续，已缴清应由借款人承担的到期应付费用；如本合同属于前述授信合同下的具体业务合同，则该授信合同下须保留有足够的可用额度；
            </p>
            <p>
              9.2.3借款人已向贷款人提供合理说明贷款资金具体用途及资金流向安排的交易合同(如有)、文件和有关证明、贷款申请以及其他有关申请贷款／提款所需的全部材料和文件，并经贷款人审查无异议；
            </p>
            <p>
              9.2.4借款人和担保人均未发生对其偿债能力产生或可能产生不利影响的任何情况；
            </p>
            <p>9.2.5借款人未发生本合同下的违约事件；</p>
            <p>
              9.2.6届时有效的法律法规和国家信贷政策、监管政策等均未对本合同一方履行本合同产生重大不利影响，也未禁止或限制本合同下的贷款发放或提取；
            </p>
            <p>9.2.7本合同约定的以及法律法规、监管政策规定的其他条件。</p>
            <p>
              9.3贷款资金采用借款人自主支付方式进行支付的，借款人应在贷款资金发放前向贷款人提供用款计划、用款交易资料，并应依照本合同约定定期向贷款人汇总报告贷款资金支付和使用情况，且贷款人有权以分析账户、
              查验资金划转凭证或现场调查等方式核查贷款资金的支付和使用是否符合本合同约定，借款人应予以配合。
            </p>
            <p>9.4贷款资金采用由贷款人受托支付方式进行支付：</p>
            <p>
              （1）借款人在此不可撤销地授权贷款人按本合同约定将贷款资金通过借款人账户或/
              及用款企业账户支付至借款人交易对手账户(无须另行征得借款人和用款企业同意，也无须通知借款人和用款企业或就划款另行提供结算凭证)，
              贷款资金到达借款人交易对手账户的时间受有关流程的操作时间、有关系统开放时间的影响，且涉及多个借款人交易对手账户的，
              如向任一借款人交易对手账户支付贷款资金不成功，可能导致全部贷款资金发放及支付不成功，由此产生的不利后果和责任贷款人不予承担，
              借款人对此并无异议并同意在上述情形发生时按照贷款人的要求配合办理相关手续；结算手续费由贷款人于支付时按贷款人届时执行的收费标准自行从借款人账户或/及用款企业账户逐笔或汇总扣收(该结算手续费也可由借款人申请提前另行主动交纳)；
            </p>
            <p>
              （2）由于借款人账户状态不正常、借款人提供的用款企业账户或/及任一借款人交易对手账户信息不完整、不准确或账户状态不正常、
              银行间支付系统或清算系统等原因或其他非贷款人过错的原因，导致款项在到达借款人账户后未能及时付出或未能及时到达用款企业账户或/
              及全部借款人交易对手账户的，由此产生的结算手续费用、贷款利息以及其他损失和延误等不利后果和责任均由借款人承担，
              但贷款人应尽合理努力继续办理向用款企业或/及全部借款人交易对手账户支付的手续，或留在银行待划转科目并通知借款人办理有关手续；
            </p>
            <p>
              （3）借款人和用款企业应按本合同约定接受贷款人对其贷款资金支付和使用的监控，本合同有效期限内贷款人有权采取限制或不开通网上银行、电话银行或手机银行等非柜面交易、拒绝办理不符合要求的资金支付等监控措施。
            </p>
            <p>
              9.5贷款资金支付／使用过程中，如借款人或用款企业违反本合同约定的方式支付／使用贷款资金的，视为借款人发生违约事件，贷款人有权变更支付/使用方式，追究借款人的违约责任及采取其他本合同及法律法规允许的救济措施。
            </p>
            <p>
              9.6贷款资金如采用借款人自主支付方式进行支付的，借款人应在贷款资金发放前向贷款人提供用款计划、用款交易资料，并应依照本合同约定定期向贷款人汇总报告贷款资金支付和使用情况，
              且贷款人有权以分析账户、查验资金划转凭证或现场调查等方式核查贷款资金的支付和使用是否符合本合同约定，借款人和用款企业应予以配合。
            </p>
            <p>
              9.7贷款一旦付至借款人账户即视为贷款已被借款人本人提取和使用，当日即为实际放款日并开始计算贷款利息。如借款人未能在本合同订立日后满足第9.2款约定的条件，则贷款人并无义务(但仍有权)执行本合同、发放贷款。
            </p>
            <p>
              9.8本合同项下贷款可由贷款人系统内的其他分支机构或网络业务系统办理，借款人通过上述方式办理的本合同项下贷款视同在贷款人处办理，且借款人对此均无异议。
            </p>
            <p>
              9.9双方在此确认，除非有确实且充分的相反证据，否则贷款人和上述办理贷款的贷款人其他分支机构内部生成的银行记账凭证是本合同项下贷款发放及本息偿还情况的有效证据。
            </p>
            <p>
              <strong>第十条 贷款利率与利息</strong>
            </p>
            <p>10.1 利率换算</p>
            <p>
              本合同项下贷款利率的计算公式为：月利率＝年利率÷12；日利率＝年利率÷360。
            </p>
            <p>
              10.2本合同有效期内，如遇国家相关政策发生变化，贷款人有权随时根据其自主判断对贷款利率中利率调整幅度或利率调整方式等相关要素进行调整。
              贷款人在进行上述调整前，将提前一定合理时间通知借款人，通知将采用手机短信、网点公告或其他贷款人认为合理的方式之一进行。
              借款人对上述调整有异议的，可选择提前还款，否则视为借款人同意接受上述调整。借款人预留在贷款人处的有效联系方式变更的，
              应及时通知贷款人。如因借款人未及时告知贷款人联系方式变更或因借款人其他原因、或其他客观原因造成贷款人通知短信无法到达借款人的，由此而产生的责任和风险由借款人自行承担。
              贷款人和借款人协议缩短贷款期限的，或借款人申请提前还款的，贷款利率仍按本合同约定执行。
            </p>
            <p>
              10.3借款人发生逾期还款、挤占挪用贷款违约情形的，贷款人按本合同约定对违约部分的金额按日计收罚息。
            </p>
            <p>10.4对不能按期支付的利息，按中国人民银行规定计收复利：</p>
            <p>
              10.4.1对贷款期内不能按期支付的利息按本合同利率计收复利，贷款本金逾期后改按本合同罚息利率计收复利；
            </p>
            <p>
              10.4.2对贷款逾期或挤占挪用期间不能按期支付的利息按本合同罚息利率计收复利。
            </p>
            <p>
              <strong>第十一条 贷款扣划</strong>
            </p>
            <p>
              11.1借款人保证按照贷款人出具的还款计划在本合同第6.2条约定的扣款账户内存放足额还本付息的存款。正常还款时，借款人同意贷款人首先从本合同第6.2条指定的的扣款账户中扣款。
            </p>
            <p>
              11.2贷款发生逾期时，贷款人有权从包括上述扣款账户和借款人在湖南三湘银行系统内开立的任一银行账户中直接扣划所欠款项，
              并按照费用、违约金、复息、罚息、利息，最后贷款本金的顺序进行清偿，直至还清全部贷款本息及其他一切相关费用为止。
              拖欠本金或利息达90天以上的，还款顺序依次为贷款本金、费用、违约金、复息、罚息和利息。贷款人有权单方变更上述清偿顺序，借款人有多笔已到期应还款项的，以贷款人确定的偿还顺序为准。
            </p>
            <p>
              11.3如因利率变动、提前还款、贷款展期等原因而导致上述借款归还的本息发生变化，贷款人仍可按照上列授权直接办理变动后相应款项的扣划手续，无需另行通知借款人、保证人和抵押人。
            </p>
            <p>
              <strong>第十二条 结算服务</strong>
            </p>
            <p>
              为便于贷款人准确评估借款人的资信情况，更好地为借款人提供服务，借款人在此同意并确认：
            </p>
            <p>
              12.1借款合同生效后，若经贷款人评估认为借款人还款能力不足的，借款人应按照贷款人要求提供还款能力证明或其他贷款人要求提供的证明资料或按照贷款人要求追加足额的担保。
            </p>
            <p>
              <strong>第十三条 借款人的权利</strong>
            </p>
            <p>13.1 有权按本合同约定提取或使用全部贷款。</p>
            <p>13.2 在取得贷款人书面同意后，有权向第三人转让债务。</p>
            <p>
              <strong>第十四条 借款人的义务</strong>
            </p>
            <p>
              14.1应及时并如实提供贷款人要求提供的文件资料，以及所有开户行、账号及存贷款余额情况，并配合贷款人的调查、审查和检查。
            </p>
            <p>
              14.2应接受贷款人对其使用信贷资金情况和有关个人财务情况的监督，自主支付情况下根据贷款人的要求定期向贷款人报告贷款资金支付情况。
            </p>
            <p>
              14.3
              应按本合同约定按时足额偿还贷款本金和利息，并确保扣款账户内有足额还款资金。
            </p>
            <p>
              14.4本合同订立后至终止前，借款人如发生对订立或履行本合同产生或可能产生不利影响的涉及借款人的任何司法程序、调解程序、仲裁程序、行政处罚程序或其他争议，应在五个工作日内通知贷款人。
            </p>
            <p>
              14.5在本合同终止之前，除非事先经过贷款人正式明确的书面同意，否则借款人及用款企业不会就其任何资产或权益进行转让、转移占有、赠与、出租、出借、承包、托管、设定担保、设立信托或以其他任何方式进行处置，
              但单笔及累计价值均低于本合同约定的贷款金额百分之五的动产或权益的处置无须事先获得贷款人的同意。
            </p>
            <p>
              14.6在本合同终止之前，借款人变更姓名、居住地址、联系地址、邮政编码、移动电话、工作单位、婚姻状况或其他个人信息的，均须在上述事项发生后3日内通过手机银行及时对上述信息进行变更。
            </p>
            <p>
              14.7借款人账户、用款企业账户发生挂失、被冻结、止付、结清或者其他非正常情况，或借款人需要变更借款人账户、用款企业账户的，借款人应及时到贷款人处办理账户变更手续。
            </p>
            <p>
              <strong>第十五条 贷款人的权利</strong>
            </p>
            <p>
              15.1有权了解借款人的财务情况和资信状况，有权要求借款人提供与借款有关的资料，有权按照国家法律法规及监管政策的规定对贷款资金的支付进行管理和控制。
            </p>
            <p>
              15.2
              有权通过账户分析、凭证查验或现场调查等方式监督或检查借款人按本合同约定用途使用贷款。
            </p>
            <p>
              15.3借款人未能履行合同规定的各项义务或违背承诺与保证或发生可能严重影响借款人偿债能力的重大不利事项的，贷款人有权按照本合同第二十一条的约定采取一种或多种措施。
            </p>
            <p>
              15.4在借款人出现失业、搬迁、伤残、婚姻变动、工作变动、经营变动、经营异常、死亡（宣告死亡）、
              丧失行为能力等情况且贷款人依自主判断认为影响借款人还款能力的，贷款人有权宣布贷款全部提前到期，要求借款人清偿本合同项下贷款本息及其他一切有关费用，或直接要求担保人承担担保责任，
              或将本合同项下所有债务落实到贷款人同意接受的受让人名下，或提供贷款人同意接受的担保措施。
            </p>
            <p>
              15.5贷款人规定的各项放款条件未完全满足前，贷款人有权不发放贷款。
            </p>
            <p>15.6 有权通过外包催收的方式对借款人进行催收。</p>
            <p>
              15.7有权按照反洗钱法律法规、监管政策及贷款人内部制度的相关要求，履行反洗钱和反恐怖融资义务，落实客户身份识别、身份资料和交易记录保存，对大额和可疑交易进行识别和报送。
            </p>
            <p>15.8 法律法规、监管政策规定的贷款人享有的其他权利。</p>
            <p>
              <strong>第十六条 贷款人的义务</strong>
            </p>
            <p>16.1 按本合同规定的条件向借款人发放贷款。</p>
            <p>
              16.2应对借款人的债务、财务等情况保密，但法律法规、监管政策另有规定、司法部门或监管机构依法要求披露、本合同另有约定、借款人已授权或贷款人为实现债权而采取的合理行为除外。
            </p>
            <p>16.3 法律法规、监管政策规定的贷款人享有的其他权利。</p>
            <p>
              <strong>第十七条 借款人承诺与保证</strong>
            </p>
            <p>
              17.1借款人具有订立和履行本合同的资格和能力，其订立和履行本合同不违反任何法律法规和对其有约束力的行政命令、生效的司法裁判／仲裁裁决，不违反任何对其有约束力的合同、协议或承诺，
              不侵犯任何第三方的合法权益，本合同对借款人具有法律约束力并可依法强制执行。
            </p>
            <p>
              17.2借款人具有有效身份证明、固定住址且具有正当职业和稳定的经济收入，信用良好，具有充足且合法的还款来源，具有充足的偿债能力；借款人在本合同下的债务以其个人财产和夫妻共同财产以及其他家庭财产承担清偿责任；
              对此，借款人已获得其配偶和其他家庭成员(如有)的同意。
            </p>
            <p>
              17.3用款企业、借款人交易对手系依法成立、合法有效存续的法律实体，使用本合同项下贷款进行的交易真实有效，
              交易合同及借款人向贷款人提供的其他相关文件和资料真实、准确、完整、合法、有效且无任何隐瞒及重大瑕疵，不存在任何欺诈、重大误导、违法、遗漏、无效或可撤销的情形；未经贷款人同意，交易合同不得变更或解除。
            </p>
            <p>
              17.4借款人按本合同约定用途使用贷款，保证不利用本合同项下贷款从事赌博等违反国家法律法规的非法活动，不用于投资股票、期货、债券等国家监管部门禁止银行贷款进入的领域，且不用于注册企业和投资入股等股本权益性投资。
            </p>
            <p>
              17.5本合同具有独立性，本合同签署之前及之后，借款人与用款企业或者借款人/用款企业与借款人交易对手等任何第三方就商品或／
              及服务的质量、交易合同履行以及权属等任何事宜发生的任何争议和纠纷，均与本合同及贷款人无关且不影响本合同效力，借款人及担保人仍应依照本合同及担保文件的约定履行义务；借款人承诺不因任一相关合同或其任何重要内容不存在、不成立、不生效、无效
              、被撤销、变更或终止或用款企业/借款人交易对手负有返还责任或其他事由拒绝或要求减免借款人的还款责任。
            </p>
            <p>
              17.6借款人配偶对借款人本贷款事宜已知悉，配偶人承诺就本合同项下的任何债务承担连带还款责任。
            </p>
            <p>
              17.7借款人保证并承诺：借款人不得违反中国反贿赂、反不正当竞争的相关法律法规、监管规定，
              不得为获得贷款直接或间接向贷款人员工及其家属或其关联方给付或承诺给付任何报酬、礼物以及其他有价值的物品或利益。
              违反本条约定的，贷款人一经发现有权立即解除合同，宣布本合同项下贷款提前到期，并提前收回已发放的部分直至全部贷款本息，给贷款人造成其他损失的由借款人承担。
            </p>
            <p class={style.contentTitle}>
              <strong>第三章 其他条款</strong>
            </p>
            <p>
              <strong>第十八条 贷款展期</strong>
            </p>
            <p>
              借款人不能按期归还本合同项下贷款，需要办理贷款展期时，应当至少在本合同到期前30天按照贷款人的要求向贷款人提出书面申请或以线上方式申请，说明展期原因并做出展期后的还款资金安排，贷款人经审查同意展期的，双方当事人另行签订展期协议
              。如果贷款人不同意展期或未能签订展期协议的，则本合同仍然有效。借款人已经占用的借款和应付利息，仍应按本合同约定偿还。
            </p>
            <p>
              <strong>第十九条 费用</strong>
            </p>
            <p>
              19.1在借款人不能按期归还本合同项下贷款本息和偿付应付费用情况下，贷款人为实现债权而支付的律师费、诉讼费、仲裁费、执行费、差旅费等所有费用，均由借款人全数负担。
              借款人授权贷款人直接从约定扣款账户扣除，如有不足，借款人保证在收到贷款人的通知后如数偿还，无需贷款人提供任何证明。
            </p>
            <p>
              19.2本合同涉及办理见证、公证或其他委托第三方提供服务的事项，相关费用由委托人自行承担。
            </p>
            <p>
              19.3借款人、贷款人应各自承担其在本合同项下应交纳的印花税。政府或行使行政管理职权的机构征收的税和行政规费等(依法贷款人须自行承担的税费除外)以及公证费用(如有)、担保费用等其他费用由借款人承担。
            </p>
            <p>
              19.4相关法律法规、监管政策对各类费用的承担有明确规定的，严格按照相关法律法规、监管政策的规定办理。
            </p>
            <p>
              <strong>第二十条 违约事件</strong>
            </p>
            <p>借款人出现下列情形之一者，均构成借款人违约事件：</p>
            <p>
              20.1向贷款人提供虚假的文件资料或隐瞒真实的重要情况，不配合贷款人的调查、审查和检查的。
            </p>
            <p>
              20.2
              未按本合同约定用途使用贷款，不接受或逃避贷款人对其财务状况、使用信贷资金情况的监督的。
            </p>
            <p>20.3未按本合同约定按时足额支付本金、利息或其他款项的。</p>
            <p>20.4 擅自将本合同项下债务转让给第三人的。</p>
            <p>
              20.5发生伤残、失业、搬迁、婚姻变动、工作变动、经营变动等任何改变，且贷款人依其自主判断认为可能危及本合同项下债权实现行为的。
            </p>
            <p>
              20.6
              借款人的继承人或受遗赠人接受继承、遗赠后拒绝为借款人履行偿还贷款本息义务的。
            </p>
            <p>
              20.7借款人有怠于管理和追索其到期债权，或以无偿及其他不适当方式处分现有主要财产等转移财产或其他逃避债务行为的。
            </p>
            <p>
              20.8
              借款人在贷款期间发生死亡、宣告死亡、失踪、宣告失踪、或者成为限制民事行为能力人或丧失民事行为能力的。
            </p>
            <p>
              20.9借款人被依法追究刑事责任或被依法受到其他强制措施或被有关机关采取了限制其某项权利的措施，影响其履行本合同义务的。
            </p>
            <p>
              20.10借款人的经常居住地发生变化，或办理出境手续或离开中国大陆，贷款人认为不利于本合同履行的。
            </p>
            <p>
              20.11借款人发生涉及婚姻关系、赡养／扶养／抚养关系变化或共有财产分割的纠纷或事件，贷款人认为可能对其偿债能力产生不利影响的。
            </p>
            <p>
              20.12借款人的任何其它贷款、担保、赔偿、承诺或其它偿债责任到期不能履行，或已进入诉讼／仲裁／强制执行程序，或其财务状况发生重大不利变化，或产生不良信用记录，或涉及对其偿债能力或对本合同的履行产生或可能产生重大不利影响的纠纷或行政处罚等。
            </p>
            <p>
              20.13
              借款人未及时履行第十四条约定的任一项义务，或违反第十七条任一项承诺与保证的。
            </p>
            <p>
              20.14借款人所控制企业及用款企业的财务或经营状况发生重大不利变化，或产生不良信用记录，或其任何重大的信贷融资、
              担保或其他偿债责任到期不能履行，或被暂停或注销主营业务是大业务的经营许可，或进入停业整顿、接管、解散、宣告破产等程序，贷款人认为可能或已经对履行本合同产生不利影响的。
            </p>
            <p>
              20.15借款人或用款企业与借款人交易对手发生争议或纠纷，或者与借款人交易对手签订的相关交易合同全部或部分内容不存在或依法不成立、不生效、无效、被撤销、变更或终止等，贷款人认为可能或已经对履行本合同产生不利影响的。
            </p>
            <p>
              20.16发生其他对贷款人的债权或／及担保权益产生或可能产生严重不利影响的事件或行为。
            </p>
            <p>
              <strong>第二十一条 违约处理</strong>
            </p>
            <p>
              一旦发生第二十条规定的任何一种违约事件时，贷款人有权采取以下一种或数种措施：
            </p>
            <p>21.1 停止发放借款人尚未提用的贷款；</p>
            <p>21.2对借款人已提用但尚未使用的贷款，停止办理支付；</p>
            <p>
              21.3宣布已发放贷款全部提前到期，收回已发放贷款的本息并要求支付相关费用；
            </p>
            <p>21.4要求借款人或担保人限期纠正其违法行为；</p>
            <p>
              21.5贷款人可直接扣收借款人在湖南三湘银行系统内开立的结算账户和/或其他账户上的存款（包括定活期账户和本外币存款，外币与本币的折算按照湖南三湘银行当日公布的汇率牌价计算），以清偿借款人的全部债务；
            </p>
            <p>21.6按违约日数、金额计收逾期贷款、挤占挪用贷款的罚息；</p>
            <p>
              21.7
              要求共同债务人、保证人或其相应的权利义务继受人在规定的期限内清偿借款人在本合同项下所欠的全部债务；
            </p>
            <p>
              21.8要求借款人赔偿因其违约而给贷款人造成的损失，包括因实现债权而导致的律师费、诉讼费等相关费用损失等；
            </p>
            <p>21.9贷款人认为必要的其他措施。</p>
            <p>
              <strong>第二十二条 </strong>
              <span>
                {' '}
                贷款人无需征得借款人同意，可将贷款人在本合同项下的权益转让给他人，并有权采取其认为适当的方式，
                包括但不限于传真、邮寄、专人送达、在公众媒体上公告等方式之一通知借款人转让事宜；贷款人转让债权的，
                本合同项下债权的担保从权利跟随一同转让，贷款人无需征得借款人的同意，可与债权受让人（新抵押权人）办理抵押登记的变更手续；但借款人未征得贷款人的书面同意，不得将其在本合同项下的任何责任或义务转让给第三人。
              </span>
            </p>
            <p>
              <strong>第二十三条</strong>
              <span>
                {' '}
                因不可抗力、通讯或网络故障或系统故障等原因导致未能按本合同约定发放贷款或办理支付的，贷款人不承担责任，但应及时通知借款人并采取补救措施。
              </span>
            </p>
            <p>
              <strong>第二十四条</strong>
              <span>
                {' '}
                借款人同意贷款人向中国人民银行及信贷征信主管部门批准建立的信息数据或有关单位、
                部门查询借款人的信用状况。贷款人有权按照法律法规、金融监管机构、征信机构或其他政府机构的要求，
                将上述信息、信贷信息在内的相关信用信息以及借款人未及时履行本合同义务产生的不良信息和借款人提供的其他信息，
                录入中国人民银行个人信用信息基础数据库、中国人民银行企业信用信息基础数据库以及其他经政府有权部门批准合法设立的信息库，
                供具有适当资格的单位／个人查询和使用。借款人同意，贷款人为业务需要也可以合理使用并披露上述信息；
                当借款人发生本合同下的违约时，贷款人有权根据借款人的违约情况酌情决定公开借款人的违约信息，并为催收借款人欠款之目的将有关的信息提供给催收机构，相应法律后果由借款人自行承担。
              </span>
            </p>
            <p>
              <strong>第二十五条</strong>
              <span>
                {' '}
                贷款人对借款人的任何违约或延误行为施以任何宽容、宽限或延缓执行本合同内贷款人应享有的权益或权利，
                均不能损害、影响或限制贷款人依本合同和有关法律规定作为债权人应享有的一切权益和权利，不能作为贷款人对任何破坏本合同行为的许可或认可，也不能视为贷款人放弃对现有或将来违约行为采取行动的权利。
              </span>
            </p>
            <p>
              <strong>第二十六条</strong>
              <span>
                {' '}
                本合同不论因何种原因在法律上成为无效或部分条款无效，只要贷款人向借款人发放了贷款，
                且借款人尚未全额结清，贷款人即对借款人享有与本项贷款有关的债权，并可立即向借款人追讨本合同项下全部贷款本息及其他一切相关费用，担保人仍有义务继续履行担保责任。
              </span>
            </p>
            <p>
              <strong>第二十七条</strong>
              <span>
                {' '}
                本合同履行完毕前，如遇法律法规、国家或监管政策变化，致使本合同的部分或全部条款不符合法律法规、
                国家或监管政策要求且国家或监管有关部门要求按新实施的法律法规、国家或监管政策执行的，贷款人可按新实施的法律法规、国家或监管政策执行相关事项并不承担任何责任。
              </span>
            </p>
            <p>
              <strong>第二十八条 送达条款</strong>
            </p>
            <p>
              28.1合同双方的有关事项的通知、协议等文件以及就合同发生纠纷时相关文件和法律文书送达，均应以书面形式按本合同首页列明的住所地作为送达地址。
            </p>
            <p>
              上述送达地址的适用范围包括非诉阶段和争议进入诉讼程序后的一审、二审、再审和执行程序。
            </p>
            <p>
              28.2任何一方在本合同项下发出的通知或文件：(1)采用亲自或委托递交的，以被通知方或其收件代理人签收之日为送达日期，收件人拒收的，
              送达人有权采取拍照、录像方式记录送达过程，并将文书留置，亦视为送达；(2)采用邮政特快专递、
              同城(包括市区与郊区)挂号邮件或其他快递方式进行邮递的，以邮件寄出之日后的第3日为送达日期；
              (3)以其他邮寄方式发出的，以寄出之日后的第5日为送达日期。依照上述规定而确定的送达日期与被通知方实际收到的日期或正式签收日期不一致时，
              以其中最早的日期为准。但为避免疑问，双方确认，提前还款申请书等贷款人要求借款人面递的文件应由借款人亲自或委派专人直接面交贷款人营业柜台。
            </p>
            <p>
              28.3借款人送达地址、联系人等事项发生变更的，应最迟于两个工作日内书面通知贷款人。
            </p>
            <p>
              借款人未按前述方式履行通知义务，其所确认的送达地址仍视为有效送达地址。若借款人送达地址变更未及时通知贷款人，
              贷款人按原送达地址送达的，或因借款人提供的变更送达地址不准确导致被退回的，均视为已送达。邮寄送达的，送达日为投寄挂号信邮戳之日；专程送达的，送达日为收件人签收之日。
            </p>
            <p>
              <strong>第二十九条</strong>
              <span>
                {' '}
                本合同如涉及二人或二人以上共同债务人的，共同债务人中任何一人对本合同项下全部债务均承担无限连带清偿义务。
                如其中一人违反本合同约定的，贷款人有权向任一债务人追索，要求其承担全部债务。并且各债务人之间互为代理人，任一债务人的同意、接受或知悉都将被视为全体债务人的同意、接受和知悉。
              </span>
            </p>
            <p>
              <strong>第三十条</strong>
              <span>
                {' '}
                本合同经借贷双方协商一致并达成书面协议可变更和解除。在达成书面协议以前，本合同仍然有效。
              </span>
            </p>
            <p>
              <strong>第三十一条</strong>
              <span>
                {' '}
                本合同项下借贷双方经过协商一致就本合同的未尽事宜、变更事项达成的书面补充协议，作为本合同附件，并构成本合同不可分割的组成部分。
              </span>
            </p>
            <p>
              <strong>第三十二条</strong>
              <span>
                {' '}
                本合同适用中华人民共和国法律法规、监管规定，借贷双方的权益受中华人民共和国法律保障。
              </span>
            </p>
            <p>
              <strong>第三十三条</strong>
              <span>
                {' '}
                本合同办理赋予强制执行效力的公证后，贷款人可以直接向有管辖权的人民法院申请强制执行。
              </span>
            </p>
            <p>
              <strong>第三十四条</strong>
              <span>
                {' '}
                借款人明确知晓本合同根据我国《电子签名法》通过数据电文形式使用电子签名（数字证书）进行线上签署。
                对于贷款人合作的获得工信部电子认证服务许可证的CA机构公示的规则予以认可并遵循。
                借款人同意授权贷款人根据借款人提交的身份认证资料代为向CA机构申请数字证书并生成可靠的电子签名，
                同意该电子签名存放于贷款人平台，且授权贷款人在借款人确认相关合同或交易时，在相关电子文件上使用该电子签名。
              </span>
            </p>
            <p>
              <strong>第三十五条</strong>
              <span>
                {' '}
                与本合同有关的借款借据、借款凭证、贷款人系统记录和凭证、以及经双方确认的其他相关文件、
                资料和借款人向贷款人单方面出具的申请书、授权书、承诺函、声明书等文件，均为本合同不可分割的组成部分，
                具同等法律效力，并已经经过第三方存证机构进行电子证据固化并保存，可以作为争议解决中的证据使用。
              </span>
            </p>
            <p>
              <strong>第三十六条</strong>
              <span> 本合同经各方当事人通过电子签名完成线上签署后生效。</span>
            </p>
            <p>
              <strong>第三十七条</strong>
              <strong>
                {' '}
                借款人确认贷款人对本合同中有关免除或限制贷款人责任、贷款人单方面拥有某些权利、增加借款人责任或限制借款人权利的条款，均已向借款人进行了提示和说明，借款人已明确全面理解相关条款含义。
              </strong>
            </p>

            <p>贷款人：（盖章)</p>
            <p>借款人：（签名）</p>
            <p class={style.footer}>
              <strong>签署日期： 年 月 日 </strong>
            </p>
          </p>
        </div>
      </div>
    );
  }
}
